import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { ROUTE_NAMES } from "@bakbak/common";
import { ForgotPasswordChangeController } from "@bakbak/controller";

import { ForgotPasswordChangeView } from "./ForgotPasswordChangeView";

export class ForgotPasswordChangeConnector extends React.PureComponent<
  RouteComponentProps<{ token: string }>
> {
  onComplete = () => {
    this.props.history.push(ROUTE_NAMES.LOGIN);
  };
  render() {
    const {
      match: {
        params: { token }
      }
    } = this.props;

    return (
      <ForgotPasswordChangeController>
        {({ submit }: any) => (
          <ForgotPasswordChangeView
            onComplete={this.onComplete}
            token={token}
            submit={submit}
          />
        )}
      </ForgotPasswordChangeController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/forgotPasswordChange/ForgotPasswordChangeConnector.tsx